var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ANZINPUTFIELD',{attrs:{"data":_vm.data,"update-node-key":_vm.updateNodeKey,"type":'number'}})
}
var staticRenderFns = []

export { render, staticRenderFns }